import { createApiActionType } from 'app/store/utils';
import { VALIDATE_SNOWFLAKE_ACCESS } from 'app/lib/types/server';

const apiType = createApiActionType('access');

export const VALIDATE_SNOWFLAKE_ACCESS_ACTION_TYPE = apiType(VALIDATE_SNOWFLAKE_ACCESS);
